import React from 'react';
import { CSSObject, Icon } from '@chakra-ui/react';
import { CheckCircle } from '@styled-icons/bootstrap/CheckCircle';
import { Stop } from '@styled-icons/octicons/Stop';

export const EstReturnsLabel: CSSObject = {
  bg: 'beta.500',
  color: 'blackAlpha.700',
  fontWeight: 'bold',
  height: '100%',
  alignItems: 'center',
  px: '1',
  width: 'auto',
};

export const PendingBetContainer: CSSObject = {
  bg: 'beta.600',
  borderRadius: 'base',
  w: 'full',
  color: 'black',
  justifyContent: 'center',
  boxShadow: 'none',
};

export const BetApprovalText: CSSObject = {
  fontSize: 'xs',
  color: 'blackAlpha.700',
  textShadow: '0px 1px 1px rgba(255, 255, 255, 0.35)',
  fontWeight: 'bold',
};

export const BetPendingApprovalText: CSSObject = {
  fontSize: 'xs',
};

export const BetRejectedText: CSSObject = {
  fontSize: 'xs',
  color: 'blackAlpha.700',
  textShadow: '0px 1px 1px rgba(255, 255, 255, 0.35)',
  fontWeight: 'bold',
};

export const ApprovedBetContainer: CSSObject = {
  color: 'blackAlpha.700',
  bg: 'green.400',
  borderRadius: 'md',
  w: 'full',
  justifyContent: 'center',
  boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.20)',
};

export const RejectedBetContainer: CSSObject = {
  bg: 'red.500',
  color: 'blackAlpha.700',
  borderRadius: 'md',
  w: 'full',
  justifyContent: 'center',
  boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.20)',
};

export const FooterContainer: CSSObject = {
  bg: 'white',
  color: 'blackAlpha.800',
  px: '0',
  h: '6',
  fontSize: '2xs',
  overflow: 'hidden',
  borderRadius: 'base',
  fontWeight: 'medium',
};

export const FooterText: CSSObject = {
  fontWeight: 'medium',
  color: 'blackAlpha.700',
};

export const EstReturnsBlock: CSSObject = {
  color: 'blackAlpha.700',
};

export const IconApprovedBet = () => (
  <Icon as={CheckCircle} boxSize="4" mr="2" />
);

export const IconRejectedBet = () => <Icon as={Stop} boxSize="4" mr="2" />;
